/* ============
 * Actions for the patient module
 * ============
 *
 * The actions that are available on the
 * patient module.
 */
import Vue from 'vue';
import PatientProxy from '@/proxies/PatientProxy';
import message from '@/constants/_message';
import types from './mutation-types';

export const getPatients = ({ commit }, data) => {
  commit(types.FETCH_PATIENT_LIST);
  new PatientProxy().fetchPatients(data).then((response) => {
    commit(types.FETCH_PATIENT_LIST_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_PATIENT_LIST_FAIL, error);
  });
};

export const update = ({ commit }, { data, id }) => {
  commit(types.UPDATE_PATIENT);
  new PatientProxy().update({ data, id }).then((response) => {
    commit(types.UPDATE_PATIENT_SUCCESS, response);
    Vue.router.push({
      name: 'patient.view',
      params: { id: response.id }
    });
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.PATIENT_UPDATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.UPDATE_PATIENT_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.PATIENT_NOT_UPDATED,
      type: 'error'
    });
  });
};

export const remove = ({ commit }, obj) => {
  commit(types.DELETE_PATIENT);
  new PatientProxy().update(obj).then((response) => {
    commit(types.DELETE_PATIENT_SUCCESS, response.id);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.PATIENT_DELETED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.DELETE_PATIENT_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.PATIENT_NOT_DELETED,
      type: 'error'
    });
  });
};

export const updatePatientData = ({commit }, data) => {
  commit(types.UPDATE_PATIENT);
  new PatientProxy().updatePatientData(data).then(() => {
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.PATIENT_UPDATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.UPDATE_PATIENT_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.PATIENT_NOT_UPDATED,
      type: 'error'
    });
  })
}

export const create = ({ commit, dispatch}, formData) => {
  commit(types.CREATE_PATIENT);
  new PatientProxy().create(formData.data).then((response) => {
    if (formData.isCareNavigator) {
      Vue.router.push({
        name: 'patientList.index'
      });
    } else {
      Vue.router.push({
        name: 'followUpPatientList.index'
      });
      const filter = {
        status: 'all',
        searchValue: response.mr_id,
        limit: 10,
        pageNo: 1,
        isFirstResponder: true
      };
      dispatch('patientList/getPatients', filter, {root: true});
    }
    commit(types.CREATE_PATIENT_SUCCESS, response);
    Vue.notify({
      group: 'notification',
      title: 'Success',
      text: message.PATIENT_CREATED,
      type: 'success'
    });
  }).catch((error) => {
    commit(types.CREATE_PATIENT_FAIL, error);
    Vue.notify({
      group: 'notification',
      title: 'Error',
      text: message.PATIENT_NOT_CREATED,
      type: 'error'
    });
  });
};

export const setPatientDataToMsg = ({commit}, data) => {
  commit(types.SET_PATIENT_DATA_TO_MESSAGE, data);
};

export const clearPatientMsgData = ({commit}) => {
  commit(types.CLEAR_PATIENT_MESSAGE_DATA);
};

export default {
  getPatients,
  create,
  update,
  remove,
  updatePatientData,
  setPatientDataToMsg,
  clearPatientMsgData
};
